<template>
  <div style="display: flex;flex-wrap: wrap">
    <el-card class="card">
      <div class="iconfont icon-people"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">用户人数：{{ data.user }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-peoplelist"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">申请人数：{{ data.join }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-read"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">单页数量：{{ data.page }}</div>
      </div>
    </el-card>
    <el-card class="card">
      <div class="iconfont icon-read1"></div>
      <div style="padding: 14px;">
        <div class="bottom clearfix">电子书数量：{{ data.ebook }}</div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "index",
  components:{

  },
  data(){
    return{
      data:{
          'user':0,
          'join':0,
          'page':0,
          'ebook':0,
      }
    }
  },
  mounted() {
    try {
      this.getinfo()
    }catch (e) {
      console.log(e)
    }
  },
  methods:{
    getinfo:async function (){
      let that = this;
      this.$_showLoading();
      let res = await that.$_api.admin('get_info');
      if(res.errcode == 0){
        this.data = res.data;
      }
      this.$_hideLoading();
    }
  }
}
</script>

<style scoped>
.card{
  width: 320px;
  text-align: center;
  margin-right: 40px;
  margin-bottom: 40px;
}
.iconfont{
  font-size: 100px;
  color: #666;
  padding: 20px;
}
</style>